module.exports = __webpack_public_path__ + "static/media/kiss-beam.9590472d.svg";